module.exports = __webpack_public_path__ + "static/slide9-future-0e387032067abe3858fc5584b66f0e03.jpg";